// ANT Design
import { message } from 'antd';

// Axios
import { instance } from './axios.instance';

// Dossiers de rangement (arbre) de la bibliothèque modèles/sections. Liste
// plate côté API (reconstruction de l'arbre via parent_id côté front).
export const getFolders = async () => {
  try {
    const res = await instance.get('/proposals/folders');
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`GET proposal folders status code ${res.status}`);
  } catch (error) {}
};

export const createFolder = async ({ name, parent_id = null }) => {
  try {
    const res = await instance.post('/proposals/folders', { name, parent_id });
    if (res.status === 201) {
      return res.data;
    }
    throw new Error(`POST proposal folder status code ${res.status}`);
  } catch (error) {
    message.error("Le dossier n'a pas pu être créé.");
    return false;
  }
};

export const updateFolder = async (id, { name, parent_id, position } = {}) => {
  try {
    const res = await instance.patch(`/proposals/folders/${id}`, {
      name,
      parent_id,
      position,
    });
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`PATCH proposal folder ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le dossier n'a pas pu être modifié.");
    return false;
  }
};

export const deleteFolder = async (id) => {
  try {
    const res = await instance.delete(`/proposals/folders/${id}`);
    if (res.status === 204) {
      return true;
    }
    throw new Error(`DELETE proposal folder ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le dossier n'a pas pu être supprimé.");
    return false;
  }
};

// Ranger un modèle/section dans un dossier (folderId null = racine).
export const moveTemplate = async (id, folderId) => {
  try {
    const res = await instance.patch(`/proposals/templates/${id}/move`, {
      folder_id: folderId,
    });
    if (res.status === 200) {
      return res.data;
    }
    throw new Error(`PATCH move template ${id} status code ${res.status}`);
  } catch (error) {
    message.error("L'élément n'a pas pu être déplacé.");
    return false;
  }
};
